const profile = (baseUrl: string): string => `${baseUrl}/users/v1/profile/customer`;

export const verifyEmail = (baseUrl: string): string => `${profile(baseUrl)}/verify-email`;
